<button tabindex="-1" class="close-button" [mat-dialog-close]="undefined" mat-icon-button><mat-icon class="notranslate">close</mat-icon></button>

<h1>FAQs about this report</h1>

<mat-dialog-content>
  <mat-accordion displayMode="flat">
    <mat-expansion-panel *ngFor="let faq of model" class="mat-elevation-z0">
      <mat-expansion-panel-header expandedHeight="fit-content" collapsedHeight="fit-content">
        <mat-panel-title class="lo_sensitive">
          {{ faq.question }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="lo_sensitive html-content" [innerHTML]="faq.answer | safeHtml"></div>
    </mat-expansion-panel>
  </mat-accordion>
</mat-dialog-content>
